/**
 * gestureRoute — pure routing decision for a generated body clip served on
 * the onGesture payload's `tracks` field: motion_class='performance' routes
 * to the override channel (tracks payload, additive suppressed); additive
 * gestures ('gesture'/absent) keep the selection channel.
 *
 * The wire contract: `motion_class` is only ever present when `tracks` is
 * also present, and its absence means 'gesture' — old servers, stock
 * gestures.json tags, and anything other than the literal string
 * 'performance' must all resolve identically to the existing additive path.
 * Kept as its own tiny module (rather than inlined in EventRuntime.js) so
 * the decision is unit-testable without EventRuntime's heavier runtime deps.
 */

/**
 * @param {any} tracks the kimodo tracks payload off the onGesture event
 *   payload, or undefined/null when the server served a stock (non-generated)
 *   tag.
 * @param {string|undefined} motionClass eventData.motionClass off the same
 *   payload.
 * @returns {'performance'|'gesture'|null} null when there is no generated
 *   clip to route at all.
 */
export function resolveGestureRoute(tracks, motionClass) {
  if (!tracks) return null
  return motionClass === 'performance' ? 'performance' : 'gesture'
}
